/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { ISystemConfigData, ISystemConfigState, ISystemMonitoringData } from "types/models/system-config";
import { RootState } from "types/reducer";

const initialState: ISystemConfigState = {
  system_config: {
    FREQUENCY_PENALTY: null,
    MAX_TOKENS: null,
    PRESENCE_PENALTY: null,
    PROMPT: '',
    TOP_P: null,
    TEMPERATURE: null,
    COMPARATIVE_PROMPT: '',
    PRETRAIN_PROMPT: '',
    DEPLOYMENT_MODEL: []
  },
  monitoring_config: {
    FREQUENCY_PENALTY: null,
    MAX_TOKENS: null,
    PRESENCE_PENALTY: null,
    PROMPT: '',
    TOP_P: null,
    TEMPERATURE: null,
    SQL_GENERATION_PROMPT: '',
    CHART_GENERATION_PROMPT: '',
    DEPLOYMENT_MODEL: []
  }
};

const SystemConfigSlice = createSlice({
  name: "system_config",
  initialState,
  reducers: {
    fetchSystemConfigCreate(
      state
    ) { },
    fetchSystemConfigSuccess(
      state: Draft<ISystemConfigState>,
      action: PayloadAction<ISystemConfigData>
    ) {
      state.system_config = {
        ...state.system_config,
        ...action.payload
      }
    },
    updateSystemConfig(
      state, action: PayloadAction<ISystemConfigData>
    ) { },
    updateSystemConfigSuccess(
      state: Draft<ISystemConfigState>,
      action: PayloadAction<ISystemConfigData>
    ) {
      state.system_config = {
        ...state.system_config,
        ...action.payload
      }
    },
    fetchSystemMlogCreate(
      state
    ) { },
    fetchSystemMlogSuccess(
      state: Draft<ISystemConfigState>,
      action: PayloadAction<ISystemMonitoringData>
    ) {
      state.monitoring_config = {
        ...state.monitoring_config,
        ...action.payload
      }
    },
    updateMlogConfig(
      state, action: PayloadAction<ISystemMonitoringData>
    ) { },
    updateMlogConfigSuccess(
      state: Draft<ISystemConfigState>,
      action: PayloadAction<ISystemMonitoringData>
    ) {
      state.monitoring_config = {
        ...state.monitoring_config,
        ...action.payload
      }
    }
  },
});

// Actions
export const fetchSystemConfig = SystemConfigSlice.actions.fetchSystemConfigCreate;
export const fetchSystemConfigSuccess = SystemConfigSlice.actions.fetchSystemConfigSuccess;
export const updateSystemConfig = SystemConfigSlice.actions.updateSystemConfig;
export const updateSystemConfigSuccess = SystemConfigSlice.actions.updateSystemConfigSuccess;

export const fetchSystemMlog = SystemConfigSlice.actions.fetchSystemMlogCreate;
export const fetchSystemMlogSuccess = SystemConfigSlice.actions.fetchSystemMlogSuccess;

export const updateMlogConfig = SystemConfigSlice.actions.updateMlogConfig;
export const updateMologConfigSuccess = SystemConfigSlice.actions.updateMlogConfigSuccess;
// Selectors
export const getDataSystemConfig = (state: RootState) =>
  state.system_config.system_config;

export const getDataSystemMlog = (state: RootState) =>
  state.system_config.monitoring_config;

// Reducer
const SystemConfigReducer = SystemConfigSlice.reducer;
export default SystemConfigReducer;
